import { BaseService } from "./base";

interface LoginResponse {
  token: string;
}

interface RefreshTokenRequest {
  escolaId?: string;
}

export interface UsuarioResponse {
  usuario: string;
  perfis: string[];
  isActive: boolean;
}

export interface UsuarioCreateRequest {
  usuario: string;
  senha: string;
  perfis: string[];
}

export interface UsuarioUpdateRequest {
  perfis?: string[];
  senha?: string;
  isActive?: boolean;
}

export interface ChangePasswordRequest {
  senhaAtual: string;
  novaSenha: string;
}

class UsuariosService extends BaseService {
  constructor() {
    super("usuarios");
  }

  login(usuario: string, senha: string): Promise<LoginResponse> {
    return this.post("login", { usuario, senha, perfil: "admin" });
  }

  refresh(data?: RefreshTokenRequest): Promise<LoginResponse> {
    return this.post("refresh", data);
  }

  getUsuarios(includeInactive = false): Promise<UsuarioResponse[]> {
    return this.get(`?includeInactive=${includeInactive}`);
  }

  getUsuario(usuario: string): Promise<UsuarioResponse> {
    return this.get(usuario);
  }

  updateUsuario(
    usuario: string,
    data: UsuarioUpdateRequest
  ): Promise<UsuarioResponse> {
    return this.put(usuario, data);
  }

  deactivateUsuario(usuario: string): Promise<UsuarioResponse> {
    return this.updateUsuario(usuario, { isActive: false });
  }

  createUsuario(data: UsuarioCreateRequest): Promise<UsuarioResponse> {
    return this.post("", data);
  }

  changeMyPassword(data: ChangePasswordRequest): Promise<void> {
    return this.put("me/password", data);
  }
}

export default new UsuariosService();
